import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import type { ReactNode } from "react";

interface TooltipProps {
  /** What the control does, shown on hover and on keyboard focus. */
  content: ReactNode;
  /** One element that takes a ref, such as a Button. */
  children: ReactNode;
  side?: "top" | "right" | "bottom" | "left";
}

/** A short description of a control. Its trigger keeps its own accessible name. */
export const Tooltip = ({ content, children, side = "bottom" }: TooltipProps) => (
  <TooltipPrimitive.Provider delayDuration={250}>
    <TooltipPrimitive.Root>
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          side={side}
          sideOffset={4}
          collisionPadding={8}
          className="z-50 max-w-72 rounded-[3px] border border-zinc-200 bg-white px-2 py-1 text-xs leading-5 text-zinc-700 shadow-md motion-safe:animate-in motion-safe:fade-in-0"
        >
          {content}
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  </TooltipPrimitive.Provider>
);
